import { actions } from "@shared/template/StoreTemplates/FilterStoreTemplate"
import { fetchPaymentType, fetchShippingMethod } from "@hub/order/src/services/contract.service"
import { toDisplayDate } from "@hub/tenant/src/helpers/accessPeriod.helper"

export default {
  ...actions,

  fillTenant({ commit }, tentant) {
    let formattedTenant = {}

    formattedTenant.uuid = tentant?.uuid
    formattedTenant.name = tentant.name
    formattedTenant.searchable = tentant.searchable
    formattedTenant.URL = tentant.url
    formattedTenant.mainColor = tentant.primary_color
    formattedTenant.secondaryColor = tentant.secondary_color
    formattedTenant.slug = tentant.slug
    formattedTenant.prefix = tentant.prefix
    formattedTenant.active = tentant.status
    formattedTenant.startDate = toDisplayDate(tentant.start_date)
    formattedTenant.endDate = toDisplayDate(tentant.end_date)
    formattedTenant.modules = tentant.modules?.map(mod => mod.uuid)
    formattedTenant.profiles = tentant.profiles?.map(p => p.uuid)
    formattedTenant.integrator = tentant?.integrator?.system
    formattedTenant.username = tentant?.integrator?.username
    formattedTenant.integratorUrl = tentant?.integrator?.url
    formattedTenant.password = tentant?.integrator?.password
    formattedTenant.dueDays = tentant?.due_days || []
    formattedTenant.paymentTypes = tentant?.payment_types || []
    formattedTenant.shippingMethods = tentant?.shipping_methods || []
    formattedTenant.qrCodeValidityTime = tentant?.qr_code_expiration_minutes || 0

    formattedTenant.integrator_info_status = {
      credit: false,
      coverage: false,
      bepeople: false
    }

    if (tentant?.integrator?.credit?.active) {
      formattedTenant.integrator_info_status.credit = tentant?.integrator?.credit?.active
      formattedTenant.credit_integrator = tentant?.integrator?.credit?.system
      formattedTenant.credit_username = tentant?.integrator?.credit?.username
      formattedTenant.credit_password = tentant?.integrator?.credit?.password
      formattedTenant.allow_cache = tentant?.integrator?.credit?.allow_cache
      formattedTenant.cache_expiration_time = tentant?.integrator?.credit?.cache_expiration_time
      formattedTenant.score_min = tentant?.integrator?.credit?.score_min
      formattedTenant.score_max = tentant?.integrator?.credit?.score_max
    }

    if (tentant?.integrator?.coverage?.active) {
      formattedTenant.integrator_info_status.coverage = tentant?.integrator?.coverage?.active
      formattedTenant.coverage_integrator = tentant?.integrator?.coverage?.system
      formattedTenant.coverage_username = tentant?.integrator?.coverage?.username
      formattedTenant.coverage_password = tentant?.integrator?.coverage?.password
    }

    if (tentant?.integrator?.bepeople?.query_usage) {
      formattedTenant.integrator_info_status.bepeople = tentant?.integrator?.bepeople?.query_usage
      formattedTenant.allow_only_qualified_legal_responsible = tentant?.integrator?.bepeople?.representative_qualification_rule
      formattedTenant.allow_add_legal_responsible = tentant?.integrator?.bepeople?.allow_freelance_representative
    }

    if (tentant?.biometry?.send_link_by_whatsapp) {
      formattedTenant.sendLinkByWhatsapp = tentant?.biometry?.send_link_by_whatsapp
    }
    if (tentant?.biometry?.whatsapp_send_origin) {
      formattedTenant.whatsappSendOrigin = tentant?.biometry?.whatsapp_send_origin
    }
    if (tentant?.biometry?.version) {
      formattedTenant.version = tentant?.biometry?.version
    }
    if (tentant?.biometry?.resend_link_interval) {
      formattedTenant.resendLinkInterval = tentant?.biometry?.resend_link_interval
    }

    commit("updateTenant", formattedTenant)
  },

  async fetchPaymentTypesOptions({ getters, commit }) {
    if (getters.getPaymentTypesOptions && getters.getPaymentTypesOptions?.length) {
      return
    }

    try {
      const data = await fetchPaymentType({ filtered: false })
      commit('setPaymentTypesOptions', data)
    } catch (error) {
      console.error(error)
    }
  },

  async fetchShippingMethodsOptions({ getters, commit }) {
    if (getters.getShippingMethodsOptions && getters.getShippingMethodsOptions?.length) {
      return
    }

    try {
      const data = await fetchShippingMethod({ filtered: false })
      commit('setShippingMethodsOptions', data)
    } catch (error) {
      console.error(error)
    }
  },

  async fetchContractOptionIfNecessary({ dispatch }) {
    dispatch('fetchPaymentTypesOptions')
    dispatch('fetchShippingMethodsOptions')
  }
}
